import { Routes } from '@angular/router';
import { AuthGuard } from '@solcre-org/core';

import { Home } from './pages/home/home';
import { Vessels } from './pages/vessels/vessels';
import { Clients } from './pages/clients/clients';
import { Ports } from './pages/ports/ports';
import { ClientView } from './pages/clients/client-view/client-view';
import { Voyages } from './pages/voyages/voyages';
import { Voyage } from './pages/voyage/voyage';
import { Currency } from './pages/currency/currency';
import { Users } from './pages/users/users';
import { Configuration } from './pages/configuration/configuration';
import { VesselDeck } from './pages/vessels/vessel-deck/vessel-deck';
import { VesselFuel } from './pages/vessels/vessel-fuel/vessel-fuel';
import { Bookings } from './pages/bookings/bookings';
import { BookingsView } from './pages/bookings-view/bookings-view';
import { FleetOps } from '../maqueta/fleet-ops/fleet-ops';
import { AuditLog } from './pages/audit-log/audit-log';
import { ChangeMyPassword } from './pages/change-my-password/change-my-password';
import { PortTariffs } from './pages/port-tariffs/port-tariffs';
import { PortTariffLines } from './pages/port-tariff-lines/port-tariff-lines';
import { PortOvertimeRules } from './pages/port-overtime-rules/port-overtime-rules';
import { CountryHolidays } from './pages/country-holidays/country-holidays';

export const AppRoutes: Routes = [
  {
    path: 'home',
    // component: Home,
    component: Bookings,
    canActivate: [AuthGuard],
  },
  {
    path: 'ports',
    component: Ports,
    canActivate: [AuthGuard],
  },
  {
    path: 'ports/:id/tariffs',
    component: PortTariffs,
    canActivate: [AuthGuard],
  },
  {
    path: 'ports/:id/tariffs/:tariffId',
    component: PortTariffLines,
    canActivate: [AuthGuard],
  },
  {
    path: 'ports/:id/overtime-rules',
    component: PortOvertimeRules,
    canActivate: [AuthGuard],
  },
  {
    path: 'clients',
    component: Clients,
    canActivate: [AuthGuard],
  },
  {
    path: 'client/:id',
    component: ClientView,
    canActivate: [AuthGuard],
  },
  {
    path: 'voyages',
    component: Voyages,
    canActivate: [AuthGuard],
  },
  {
    path: 'voyages/:id',
    component: Voyage,
    canActivate: [AuthGuard],
  },
  {
    path: 'currency',
    component: Currency,
    canActivate: [AuthGuard],
  },
  {
    path: 'users',
    component: Users,
    canActivate: [AuthGuard],
  },
  {
    path: 'configuration',
    component: Configuration,
    canActivate: [AuthGuard],
  },
  {
    path: 'country-holidays',
    component: CountryHolidays,
    canActivate: [AuthGuard],
  },
  {
    path: 'vessels',
    component: Vessels,
    canActivate: [AuthGuard],
  },
  {
    path: 'vessels/:id/decks',
    component: VesselDeck,
    canActivate: [AuthGuard],
  },
  {
    path: 'vessels/:id/fuel',
    component: VesselFuel,
    canActivate: [AuthGuard],
  },
  {
    path: 'bookings',
    component: Bookings,
    canActivate: [AuthGuard],
  },
  {
    path: 'bookings/:id',
    component: BookingsView,
    canActivate: [AuthGuard],
  },
  {
    path: 'audit-log',
    component: AuditLog,
    canActivate: [AuthGuard],
  },
  {
    path: 'change-my-password',
    component: ChangeMyPassword,
    canActivate: [AuthGuard],
  },
  {
    path: 'maqueta/fleet-ops',
    component: FleetOps,
  },
];
